import React from 'react';

export default function FormValues({ contacts }) {
  if (contacts.length === 0) {
    return <input type='text' className='hidden' required />;
  }

  return contacts.map((contact) => (
    <input
      key={contact.key}
      type='hidden'
      name={contact.key}
      value={contact.label}
    />
  ));
}
